import { useEffect, useState, type ReactNode } from "react";
import HeaderV2 from "./HeaderV2";
import AuthModal from "@/components/AuthModal";
import { useLanguageRouter } from "@/hooks/useLanguageRouter";
import "@/locales/registerNewLandingI18n";
import "@/locales/registerLandingV2I18n";
import "@/pages/landing-v2.css";
import "@/pages/landing-v2-app.css";
import "@/pages/creative-tools.css";

export default function CreativeLandingShell({
  children,
}: {
  children: ReactNode;
}) {
  const [authOpen, setAuthOpen] = useState(false);
  const { navigate, withLanguagePath } = useLanguageRouter();
  const [theme, setTheme] = useState<"dark" | "light">(() => {
    try {
      return localStorage.getItem("solmi-theme") === "light" ? "light" : "dark";
    } catch {
      return "dark";
    }
  });
  useEffect(() => {
    if (!document.querySelector("link[data-slv2-fonts]")) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,700;1,9..40,400;1,9..40,500&family=DM+Mono:wght@300;400;500&display=swap";
      link.setAttribute("data-slv2-fonts", "");
      document.head.append(link);
    }
  }, []);
  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    try {
      localStorage.setItem("solmi-theme", next);
    } catch {}
  };
  return (
    <div className="slv2 creative-landing" data-theme={theme}>
      <HeaderV2
        onLogin={() => setAuthOpen(true)}
        onJoin={() => setAuthOpen(true)}
        onThemeToggle={toggleTheme}
      />
      {children}
      <footer>
        <a
          className="mark"
          href={withLanguagePath("/")}
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          Solmi<i>.</i>
        </a>
        <nav aria-label="Footer">
          {[
            ["All tools", "/creative-tools"],
            ["Pricing", "/subscription"],
            ["Help", "/help"],
          ].map(([label, href]) => (
            <a
              key={href}
              href={withLanguagePath(href)}
              onClick={(e) => {
                e.preventDefault();
                navigate(href);
              }}
            >
              {label}
            </a>
          ))}
        </nav>
      </footer>
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
    </div>
  );
}
